import React from 'react';
import {Button, Input} from 'semantic-ui-react';
import StatusModal from './modals/StatusModal';

const HeaderActions = ({
  state,
  loading,
  dealer,
  warrantyStatus,
  downloadTxtFile,
  processedWarrantyList,
  handleAccountChange,
  handleFilterChange,
}) => {
  const {account, twcNum, selectedStatus, filteredRows} = state;
  const disableStatus = selectedStatus === 'TODOS' || selectedStatus === '01';
  const isWarrantySelected = processedWarrantyList.some((warranty) => warranty.checked);

  const getTotalAmountWarranty = (list) => {
    if (list === null || list.length === 0) {
      return 0;
    }

    const total = list.reduce((a, b) => +a + +b.original.totalTwc, 0);
    return total.toFixed(2);
  };

  const totalAmountWarranty = getTotalAmountWarranty(
    filteredRows
  );

  return (
    <div className="title-bar-actions">
      <Input
        fluid
        size="small"
        style={{'width': '120px'}}
        name="twcTotal"
        placeholder="TWC Total"
        maxLength="10"
        value={totalAmountWarranty}
        disabled={true}
      />
      <Input
        fluid
        size="small"
        style={{'width': '120px'}}
        name="twcNum"
        placeholder="Número TWC"
        maxLength="10"
        onChange={(event) => handleFilterChange(event)}
        value={twcNum || ''}
        disabled={selectedStatus !== '05'}
      />
      <Input
        fluid
        size="small"
        style={{'width': '120px'}}
        name="list-sequences-containe"
        placeholder="Cta. de Cobro"
        maxLength="7"
        onChange={(event) => handleAccountChange(event)}
        value={account || ''}
        disabled={selectedStatus !== '05'}
      />
      <Button
        primary
        className="toyota-primary"
        onClick={downloadTxtFile}
        disabled={loading || !twcNum}
      >
        Generar Archivo
      </Button>
      {!disableStatus && (
        <StatusModal
          {...state}
          dealer={dealer}
          isWarrantySelected={isWarrantySelected}
          warrantyStatus={warrantyStatus}
          processedWarrantyList={processedWarrantyList}
        />
      )}
    </div>
  );
};

export default HeaderActions;
